'use client';

import { FunnelCheckoutResponse } from 'app/api/funnel-checkout/route';
import { Result, ResultJSON } from 'lib/result';
import { createUrl } from 'lib/utils';
import { useEffect, useState } from 'react';
import { Fetcher } from 'swr';
import useSWRImmutable from 'swr/immutable';

type CheckoutUrlPayload = {
  sku: string;
  quantity?: number;
  productLine: string;
  funnelName: string;
  lander?: string;
  queryParams?: URLSearchParams
  ancestor?: number | null;
}

export async function createCheckoutUrl({
  sku,
  quantity,
  productLine,
  funnelName,
  lander,
  queryParams,
  ancestor = null
}: CheckoutUrlPayload): Promise<ResultJSON<FunnelCheckoutResponse>> {
  try {
    let url = '/api/funnel-checkout';
    if (queryParams) {
      url = createUrl(url, queryParams);
    }
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        sku,
        quantity,
        productLine,
        funnelName,
        lander,
        ancestor,
      }),
    });

    const result = await response.json();
    return result;
  } catch (error: any) {
    console.error('Error:', error);
    return Result.fail(error);
  }
}

const fetcher: Fetcher<ResultJSON<FunnelCheckoutResponse>, string> = (key: string) => {
  const payload = JSON.parse(key);
  const {
    sku,
    quantity,
    productLine,
    funnelName,
    lander,
    queryParams,
    ancestor = null
  } = payload;

  return createCheckoutUrl({
    sku,
    quantity,
    productLine,
    funnelName,
    lander,
    queryParams: (queryParams && Object.keys(queryParams).length !== 0) ? new URLSearchParams(queryParams) : undefined,
    ancestor
  })

};
export function useCheckoutUrl({
  sku,
  quantity,
  productLine,
  funnelName,
  lander,
  queryParams
}: CheckoutUrlPayload) {
  const { data, error, isLoading } = useSWRImmutable(JSON.stringify({
    sku,
    quantity,
    productLine,
    funnelName,
    lander,
    queryParams: queryParams?.toString()
  }),
    fetcher,
    {
      // dont duplicate a request w/ same key for 1hr
      dedupingInterval: 3_600_000,
    });
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
    }
  }, [initialized]);

  const loading = initialized ? isLoading : true;

  if (data?.isFailure) {
    console.log(data);
  }
  if (error) {
    console.log(error);
  }

  let checkoutUrl;
  if (!loading) {
    checkoutUrl = data?.value?.checkoutUrl;
  }

  return {
    loading,
    checkoutUrl
  };
}
